<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('assetTypeDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>
        <div>
            <h3 class="text-center mb-4">{{ data.name }} 
                <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettypeinfoset/' + this.$route.params.assetTypeId">
                    <button class="btn btn-secondary float-end">
                        {{ $t('detail') }}
                    </button>
                </RouterLink>
            </h3>
            <div class="row mb-4">
                <div class="col-sm-3">
                    <div class="card text-center">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t("activityList") }}</h5>
                        </div>
                        <ul class="list-group list-group-flush" v-if="activityList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in activityList" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/activity/' + item.id ">
                                {{ item.name || item.id }}
                            </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/activitycreate' ">
                                <button class="btn btn-sm btn-light">{{ $t('addActivity')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="card text-center">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t("performanceList") }}</h5>
                        </div>
                        <ul class="list-group list-group-flush" v-if="performanceList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in performanceList" :key="i">
                                <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/performance/' + item.id ">
                                    {{ item.name || item.id }} 
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/performancecreate'">
                                <button class="btn btn-sm btn-light">{{ $t('addPerformance')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="card text-center">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t("benefitList") }}</h5>
                        </div>
                        <ul class="list-group list-group-flush" v-if="benefitList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in benefitList" :key="i">
                                <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/benefit/' + item.id ">
                                    {{ item.name || item.id }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/benefitcreate' ">
                                <button class="btn btn-sm btn-light">{{ $t('addBenefit')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="card text-center">
                        <div class="card-body">
                            <h5 class="card-title">{{ $t("lifeCycleList") }}</h5>
                        </div>
                        <ul class="list-group list-group-flush" v-if="lifeCycleList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in lifeCycleList" :key="i">
                               <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/lifecycle/' + item.id ">
                                    {{ item.name || item.id }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/lifecyclecreate' ">
                                <button class="btn btn-sm btn-light">{{ $t('addLifeCycle')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="text-center mb-4">{{ $t("parameters") }}</h3>
            <div class="row mb-4">
                <div class="col-sm-3 mb-4" v-for="(item, i) in parameterList" :key="i">
                    <div class="card text-center">
                        <div class="card-body">
                            <RouterLink style="color: black" :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/parameter/' + item.id ">
                                <h5 class="card-title">{{ item.name }}</h5>
                            </RouterLink>
                        </div>
                        <ul class="list-group list-group-flush" v-if="curveList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in filteredCurveList(curveList, item.id)" :key="i">
                                <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/curve/' + item.id">
                                    {{ item.name }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/curvecreate/' + item.id ">
                                <button class="btn btn-sm btn-light">{{ $t('addCurve')}}</button>
                            </RouterLink>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" v-if="isUserAdmin">
                    <div class="card text-center">
                        <div class="card-body ">
                            <ul class="list-group list-group-flush" > 
                                <li class="list-group-item" >
                                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/parametercreate/'">
                                        <button class="btn btn-sm btn-light">{{ $t('addParameter')}}</button>
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="text-center mb-4">{{ $t("kpi") }}</h3>
            <div class="row mb-4">
                <div class="col-sm-3 mb-4" v-for="(item, i) in kpiList" :key="item.id">
                    <div class="card text-center">
                        <div class="card-body">
                            <RouterLink style="color: black" :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/kpi/' + item.id ">
                                <h5 class="card-title">{{ item.name }}</h5>
                            </RouterLink>
                        </div>
                        <ul class="list-group list-group-flush" v-if="evaluationList.length >= 0"> 
                            <li class="list-group-item" v-for="(item, i) in filteredEvaluationList(evaluationList, item.id)" :key="i">
                                <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/evaluation/' + item.id">
                                    {{ item.name }}
                                </RouterLink>
                            </li>
                        </ul>
                        <div class="card-body" v-if="isUserAdmin">
                            <div class="float-start">
                                <button class="btn btn-sm btn-light me-1" :disabled="i === 0" @click="moveKpi(i, -1)">
                                    <i class="fa fa-arrow-left"></i>
                                </button>
                            </div>
                            <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/evaluationcreate/' + item.id ">
                                <button class="btn btn-sm btn-light">{{ $t('addEvaluation')}}</button>
                            </RouterLink>
                            <div class="float-end">
                                <button class="btn btn-sm btn-light" :disabled="i === kpiList.length - 1" @click="moveKpi(i, 1)" >
                                    <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" v-if="isUserAdmin">
                    <div class="card text-center">
                        <div class="card-body ">
                            <ul class="list-group list-group-flush" > 
                                <li class="list-group-item" >
                                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/kpicreate/'">
                                        <button class="btn btn-sm btn-light">{{ $t('addKpi')}}</button>
                                    </RouterLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssetTypeApi from "../../api/server/assetType";
import ActivityApi from "../../api/server/activity";
import LifeCycleApi from "../../api/server/lifeCycle";
import BenefitApi from "../../api/server/benefit";
import PerformanceApi from "../../api/server/performance";
import DatasetApi from "../../api/server/dataset";
import ModelingApi from "../../api/server/modeling";
import CheckIfUserIsAdmin from '../../authCache';
import ParameterApi from "../../api/server/parameter";
import CurveApi from "../../api/server/curve";
import KeyPerformanceIndicatorApi from "../../api/server/kpi.js";
import EvaluationApi from "../../api/server/evaluation.js";

export default {
    name: "modelingdetail",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.isUserAdmin = await CheckIfUserIsAdmin();

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            var assetTypeId = this.$route.params.assetTypeId;
            this.data = await AssetTypeApi.assetTypeDetail(this.$route.params.id, assetTypeId);
            this.dataset = await DatasetApi.datasetDetail(this.$route.params.id, this.data.datasetId);
            var activityList = await ActivityApi.activityList(this.$route.params.id);
            this.activityList = activityList.filter(a => a.assetTypeId == assetTypeId);

            var lifeCycleList = await LifeCycleApi.lifeCycleList(this.$route.params.id);
            this.lifeCycleList = lifeCycleList.filter(a => a.assetTypeId == assetTypeId);
            
            var benefitList = await BenefitApi.benefitList(this.$route.params.id);
            this.benefitList = benefitList.filter(a => a.assetTypeId == assetTypeId);
            var performanceList = await PerformanceApi.performanceList(this.$route.params.id);
            this.performanceList = performanceList.filter(a => a.assetTypeId == assetTypeId);

            var parameterList = await ParameterApi.parameterList(this.$route.params.id);
            this.parameterList = parameterList.filter(a => a.assetTypeId == assetTypeId);

            var kpiList = await KeyPerformanceIndicatorApi.kpiList(this.$route.params.id);
            this.kpiList = kpiList.filter(a => a.assetTypeId == assetTypeId).sort((x, y) => x.order - y.order);

            this.curveList = await CurveApi.curveList(this.$route.params.id);

            this.evaluationList = await EvaluationApi.evaluationList(this.$route.params.id);

            this.pending = false;
        },
        moveKpi(i, direction) {
            const list = [...this.kpiList];
            const j = i + direction;
            if (j < 0 || j >= list.length || i < 0 || i >= list.length) return;

            if (list.some(k => k.order == null || k.order <= 0)) {
                list.forEach((k, idx) => { k.order = idx + 1; });
            }

            const tmp = list[i].order;
            list[i].order = list[j].order;
            list[j].order = tmp;

            list.sort((x, y) => x.order - y.order);
            this.kpiList = list;
            this.updateKpiOrder();
        },
        async updateKpiOrder() {
            await KeyPerformanceIndicatorApi.updateKPIOrder(this.$route.params.id, this.kpiList);
        },
        filteredCurveList(curveList, parameterId) {
            return curveList.filter(a => a.parameterId == parameterId);
        },
        filteredEvaluationList(evaluationList, kpiId) {
            return evaluationList.filter(a => a.keyPerformanceIndicatorId == kpiId);
        },
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'assetTypeUpdated',
            type: 'success'
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: ""
            },
            dataset: {},
            datasetList: [],
            assetTypeList: [],
            activityList: [],
            lifeCycleList: [],
            benefitList: [],
            performanceList: [],
            parameterList: [],
            curveList: [],
            kpiList: [],
            evaluationList: [],
            activityToDeleteId: 0,
            showActivityDeleteModal: false,
            pending: true,
            isUserAdmin: false
        }
    }
};
</script>